import { render, staticRenderFns } from "./HiddenRectificationForm.vue?vue&type=template&id=ba8d3584&scoped=true"
import script from "./HiddenRectificationForm.vue?vue&type=script&lang=js"
export * from "./HiddenRectificationForm.vue?vue&type=script&lang=js"
import style0 from "./HiddenRectificationForm.vue?vue&type=style&index=0&id=ba8d3584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8d3584",
  null
  
)

export default component.exports